import React from 'react';
import { Tooltip, Box, Grid } from '@mui/material';
import { CheckCircle, Unpublished } from '@mui/icons-material';
import { List } from 'immutable';
import { permit } from '@lba-dev/package.local-globals/restrictions';

const VerificationError = ({ component, analyseIA, field, user }) => {
  const verifications = analyseIA && analyseIA.get('verifications', new List());
  const verification =
    verifications && verifications.find(v => v.get('champ') === field);
  return permit(user) && verification ?
    <Grid
      container
      item
      xs={12}
      sm={4}
      alignItems="center"
      spacing={1}
    >
      <Grid item xs={10}>
        {component}
      </Grid>
      <Grid item xs={2}>
        <Tooltip title={verification.get('reason')} arrow>
          <Box sx={{ display: 'inline-flex', cursor: 'pointer', mt: 2 }}>
            {verification.get('correct', false) ?
              <CheckCircle color="success" fontSize="medium" /> :
              <Unpublished color="error" fontSize="medium" />
            }
          </Box>
        </Tooltip>
      </Grid>
    </Grid>
    : component;
};

export default VerificationError;
